import YouTube from 'react-youtube';
import { StickyContainer, Sticky } from 'react-sticky';

var DisplayToggleControl = require("components/utility/DisplayToggleControl");
var StepProgressMeter = require("components/utility/StepProgressMeter");
var LearningSeries = require("lib/academic/LearningSeries");

class TutorialDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {};
	}

	onViewChange(view) {
		this.props.changeLevelF(view);
	}

	onEnd(videoKey) {
    	this.props.completeVideoF(videoKey)
    	window.wrNotifications.triggerDropDownNotification({
     		title: "Video Finished!", text: "We're sure you learned a lot!", icon: "ok-sign" 
     	});
  	}

  	renderProgressMeter() {
  		// Step Progress Meter for progress within a module level *
		
		var allVideos = this.props.allVideos;
		var videosCount = allVideos.length;
		var iconPathStems = [];

		_.times(videosCount, (n) => {
			iconPathStems.push("misc/film");
		});
		
		var currentStep = LearningSeries.countComplete(this.props.allVideos, this.props.completedVideos) + 1;
		
		var progressMeter = (
			<StepProgressMeter numSteps={ videosCount } currentStep={ currentStep } iconPathStems={ iconPathStems } />
		)

		var progressMeterArea = (
			<div className="progressBarContainer">{ progressMeter }</div>
		)

  		return progressMeterArea
  	}

  	renderVideoContainer(stickyProps) {
  		var mainVideo = this.props.video;
  		
  		// Actual iframe video from YouTube iframe API and video title* 
		var videoTitle = (
			<p className="videoTitle">{ mainVideo.title }</p>
		)
		var opts = { height: '315', width: '560' }
		var videoID = mainVideo.videoID
		var iframeVideo = (
			<YouTube videoId={ videoID } opts={ opts } onEnd={ this.onEnd.bind(this, mainVideo.key) } />
		)

		// Checks and sets content based on whether action is complete *
		// If there is an action related to this video, this is it *

		if (this.props.action) {
			var mainAction = this.props.action;               // -- .title for once its completed? and icon? 
			var actionCompleted = _.includes(this.props.completedActions, mainAction.key)
			var nextStepDescription = mainAction.description

			if (actionCompleted) {
				var completedActionClass = "complete"
			}

			var actionContent = (
				<div className={ "actionContent " + completedActionClass }>
					<p className="nextStepLabel">Next Step:</p>
					<p className="actionContentText">
						<span className="glyphicon glyphicon-ok-circle"></span>
						{ nextStepDescription }
					</p>
		       	</div>
			)
		}

  		if (stickyProps.isSticky) {
  			var stickyStyle = _.extend({}, stickyProps.style, { paddingTop: "55px" });
  		}
		var videoContainer = (
			<div className="videoContainer" style={ stickyStyle }>
				{ videoTitle }
	   			{ iframeVideo }
	   			<div className="actionContainer">{ actionContent }</div>
			</div>
  		)
  		return videoContainer
  	}

  	renderToggleOptions() {
  		var toggleOptions = [
			{ key: LearningSeries.BEG_LEVEL, text: "Beginner" },
			{ key: LearningSeries.INT_LEVEL, text: "Intermediate"},
			{ key: LearningSeries.ADV_LEVEL, text: "Advanced" }
   		];

		var displayToggleControl = (
			<DisplayToggleControl options={ toggleOptions }
				onChange={ this.onViewChange }
				activeOptionKey={ this.props.video.level } />
		);

  		return (
  			<div className="toggleLinks">{ displayToggleControl }</div> 
  		)
  	}

  	renderNextVideosDisplay() {
  		var allVideos = this.props.allVideos;
		var videosCount = allVideos.length
		var nextVideosDisplay = _.map(allVideos, (video) => {
			var videoKey = video.key;
			if (_.includes(this.props.completedVideos, video.key)) {
				var completedVideoClass = "completedVideo"
			}
			return (
				<div className={ "nextVideo clickableElement " + completedVideoClass } 
					onClick={ this.props.changeVideoF.bind(this, video) }
					key={ video.key }>
					<div>
						<span className="glyphicon glyphicon-film"></span>
						<span className="videoTitle">{ video.title }</span>
					</div>
					<span>{ video.description }</span>
				</div>
			);
		});
		return nextVideosDisplay;
  	}

	render() {
		var mainVideo = this.props.video;

		// don't display the toggle for the quick start module because only one level
		if (this.props.video.module != LearningSeries.QUICK_MODULE) {
			var toggleOptions = this.renderToggleOptions();
		}

		var videoContainer = (
			<StickyContainer>
				<div className="stickyContainer">
					<Sticky topOffset={ -55 }>{ this.renderVideoContainer }</Sticky>
				</div>
				<div className="otherModuleVideosContainer">
					{ toggleOptions }
					<div className="otherModuleVideos">
						{ this.renderNextVideosDisplay() }
						<span className="videoTitle"></span>
					</div>	
				</div>
			</StickyContainer>
		)

		

		return (
			<div className="tutorialDisplay">
				{ this.renderProgressMeter() }
				{ videoContainer }
			</div>
		)
	}
}

TutorialDisplay.propTypes = PageStrictPropTypes({
	// array of videos that have been watched
	completedVideos: PropTypes.array.isRequired,
	// array of actions that have been done
	completedActions: PropTypes.array.isRequired,

	// current video to display
	video: PropTypes.object.isRequired,
	// corresponding action for current video, if there is one
	action: PropTypes.object,

	// all videos in the current module and level
	allVideos: PropTypes.array.isRequired,

	// function to call when changing videos, provide new video key
	changeVideoF: PropTypes.func.isRequired,
	// function to call when changing levels, provide new level
	changeLevelF: PropTypes.func.isRequired,
	// function to call when changing modules, provide new module
	changeModuleF: PropTypes.func.isRequired,

	// function to call to complete a video, provide video key
	completeVideoF: PropTypes.func.isRequired,
});

module.exports = TutorialDisplay;


// WEBPACK FOOTER //
// ./modules/components/users/teachers/tutorials/TutorialDisplay.js